import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import HomePage from '../views/HomePage.vue'
import ProgrammingPage from '../views/Programming.vue'
import ProjectsPage from '../views/ProjectPage.vue'
import ProjectCollage from '../components/objects/Project.vue'
import Quote from '../components/Quote.vue'
import ContactPage from '../views/ContactPage.vue'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage
  }
  , {
    path: '/contact',
    name: 'Contact Quote',
    component: ContactPage,
  }
,  {
    path: '/requestquote',
    name: 'Request Quote',
    component: Quote,

  },
  {
    path: '/projects',
    name: 'Projects',
    component: ProjectsPage
  }, 
  
  {
    path: '/project',
    name: 'Project Collage',
    component: ProjectCollage
  }, 
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
